import * as React from 'react';

const SvgLocation = (props) => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M9.855 13.134c1.54-1.964 3.48-4.817 3.48-6.728 0-3.17-2.388-5.74-5.334-5.74-2.945 0-5.333 2.57-5.333 5.74 0 1.911 1.94 4.764 3.48 6.728C6.95 14.158 7.351 14.67 8 14.67c.65 0 1.05-.512 1.854-1.536ZM8.001 8.667a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z'
    />
  </svg>
);

export default SvgLocation;
